<template>
    <div>
        <div class="main_content">
            <div class="WP_form">
                <!-- 银行编号类型 -->
                <!-- <div class="info_title" style="margin-bottom: 6upx;">{{ $t('bankset.Type') }}</div>
                <div class="info_radio">
                    <van-radio-group v-model="formData.bankCode" direction="horizontal">
                        <van-radio :name="item.value" checked-color="#1989fa" v-for="(item, index) in columns"
                            :key="index">{{ item.label }}</van-radio>
                    </van-radio-group>
                </div> -->
                <!-- 收款人名�?-->
                <div class="info_title">{{ $t('bankset.AccountName') }}</div>
                <div class="info_input">
                    <a-input v-model="formData.accountName" :placeholder="$t('bankset.NameOfTheAccountHolder')"
                        allowClear></a-input>
                </div>
                <!-- 收款人手机号 -->
                <div class="info_title">{{ $t('bankset.AccountPhone') }}</div>
                <div class="info_input">
                    <a-input v-model="formData.accountPhone" type="number" :placeholder="$t('bankset.EnterPhoneNumber')" allowClear></a-input>
                </div>
                <!-- 收款账号 -->
                <div class="info_title">{{ $t('bankset.PayeeAccount') }}</div>
                <div class="info_input">
                    <a-input v-model="formData.accountPayee" :placeholder="$t('bankset.PayeeAccount')" allowClear></a-input>
                </div>
                <!-- 银行编号 -->
                <div v-if="formData.bankCode == 'SBP'" class="info_title">{{ $t('bankset.BankName') }}</div>
                <div v-if="formData.bankCode == 'SBP'" class="info_input" @click="onShowChannelPopup">
                    <a-input v-model="formData.sbpBankCodeName" disabled :placeholder="$t('bankset.ChooseBank')" allowClear
                        style="pointer-events: none;">
                        <div slot="suffix" class="iconfont icon-xiangyou"></div>
                    </a-input>
                </div>
                <div class="info_title">{{ $t('bankset.WithdrawPassword') }}</div>
                <div class="info_input">
                    <a-input-password v-model="formData.withdrawPassword"
                        :placeholder="$t('bankset.InputWithdrawalPassword')" autocomplete="new-password"
                        allowClear></a-input-password>
                </div>
                <div class="info_title">{{ $t('bankset.ConfirmWithdrawalPassword') }}</div>
                <div class="info_input">
                    <a-input-password v-model="formData.withdrawPasswordVerify"
                        :placeholder="$t('bankset.InputConfirmWithdrawalPassword')" autocomplete="new-password"
                        allowClear></a-input-password>
                </div>
            </div>
            <div class="btn_box">
                <div class="action_btn" @click="handleSubmit">
                    <span>{{ $t('bankset.Save') }}</span>
                </div>
            </div>
        </div>
        <channelPopupRussia ref="channelPopup" :name="formData.sbpBankCode" @onConfirm="onChannelPopupConfirm">
        </channelPopupRussia>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { deepClone } from '@/utils'
import {
    saveBankRussia,
    getBankRussia,
    updateBankRussia,
    getBankListRussia
} from '@/api/withdraw'
import channelPopupRussia from './modules/channelPopupRussia.vue'
import md5 from 'md5'
export default {
    name: 'banksetRussia',
    components: { channelPopupRussia },
    data() {
        return {
            show: false,
            columns: [
                // { value: 'CARD', label: 'CARD' },
                { value: 'SBP', label: 'SBP' }
            ],
            formData: {
                bankCode: 'SBP',
                accountName: '',
                accountPhone: '',
                accountPayee: '',
                sbpBankCode: '',
                sbpBankCodeName: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$emit('close')
        },
        async open() {
            this.formData = {
                bankCode: 'SBP',
                accountName: '',
                accountPayee: '',
                sbpBankCode: '',
                sbpBankCodeName: '',
                withdrawPassword: '',
                withdrawPasswordVerify: ''
            }
            const { result } = await getBankListRussia()
            const BankList = result
            getBankRussia().then(res => {
                if (res.code) return
                const D = res.result
                this.formData = {
                    ...D,
                    withdrawPassword: ''
                }
                if (BankList && BankList[D.sbpBankCode]) this.formData.sbpBankCodeName = BankList[D.sbpBankCode]
            })
            this.$nextTick(() => { })
        },
        onShowChannelPopup() {
            this.$refs.channelPopup.open()
        },
        onChannelPopupConfirm(e) {
            this.formData.sbpBankCode = e.code
            this.formData.sbpBankCodeName = e.name
            this.$forceUpdate()
        },
        async handleSubmit() {
            if (!this.formData.bankCode) {
                Toast(this.$t('bankset.ChooseCertificateType'))
                return
            }
            if (!this.formData.accountName) {
                Toast(this.$t('bankset.InputAccountName'))
                return
            }
            if (!this.formData.accountPhone) {
                Toast(this.$t('bankset.PleaseEnterPhoneNumber'))
                return
            }
            // const PhoneReg = /^\d{10}$/
            // if (!PhoneReg.test(this.formData.accountPhone)) {
            //     Toast(this.$t('login.PhoneFormat'))
            //     return
            // }
            if (!this.formData.accountPayee) {
                Toast(this.$t('bankset.InputPayeeAccount'))
                return
            } else {
                this.formData.accountPayee = this.formData.accountPayee.trim()
            }
            if (!this.formData.withdrawPasswordVerify) {
                Toast(this.$t('bankset.InputConfirmWithdrawalPassword'))
                return
            }
            if (this.formData.withdrawPassword !== this.formData.withdrawPasswordVerify) {
                Toast(this.$t('bankset.InputInconsistentWithdrawPassword'))
                return
            }
            const form = deepClone(this.formData)
            if (form.withdrawPassword) form.withdrawPassword = md5(form.withdrawPassword)
            if (form.withdrawPasswordVerify) form.withdrawPasswordVerify = md5(form.withdrawPasswordVerify)
            let result
            if (form.id) {
                result = await updateBankRussia(form)
            } else {
                result = await saveBankRussia(form)
            }
            Toast(result.message)
            if (result.code) return
            this.$emit('succ')
            this.close()
        }
    }
}
</script>

<style scoped lang="scss">
    @import '@/common/styles/viriables.scss';
.header {
    display: flex;
    height: 1rem;
    padding-left: .46rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: .1rem;
    background: $bg-component-ocean-deep-color;

    &>div:first-child {
        font-size: .32rem;
        font-weight: bold;
        color: $font-color;
    }

    .close {
        color: $font-component-muted-color;
        font-size: .36rem;
        font-weight: bold;
        height: 1rem;
        width: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}

.main_content {
    overflow: auto;

    .WP_form {
        padding: 0 .28rem;

        .info_title {
            margin-bottom: .18rem;
            font-size: .28rem;
            color: $font-color;
            margin-top: .24rem;
            text-align: left;
        }

        .info_radio {
            width: 100%;
            font-size: .26rem;
            font-weight: 400;
            padding-right: .28rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;

            ::v-deep .van-radio {
                margin-bottom: .18rem;

                .van-radio__label {
                    color: $font-component-muted-color;
                }

                .van-radio__icon--checked {
                    &+.van-radio__label {
                        color: $font-color;
                    }
                }
            }
        }

        .info_input {
            ::v-deep input::-webkit-outer-spin-button {
                -webkit-appearance: none;
            }

            ::v-deep input::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }

            ::v-deep input[type='number'] {
                -moz-appearance: textfield;
            }

            ::v-deep .ant-input-suffix {
                .ant-input-clear-icon {
                    color: $font-component-field-color;
                    font-size: .32rem;
                    margin-right: .1rem;
                }

                .icon-xiangyou {
                    margin-right: .1rem;
                    font-size: .3rem;
                    color: $font-component-muted-color;
                }
            }

            ::v-deep .ant-input-password {
                .ant-input {
                    padding-right: 1rem;
                }

                .ant-input-suffix {
                    .ant-input-password-icon {
                        margin-right: .1rem;
                        font-size: .3rem;
                        color: $font-component-muted-color;
                    }
                }
            }

            ::v-deep .ant-input {
                background-color: $bg-component-input-focus-color !important;
                border-radius: 0.14rem;
                font-size: 0.22rem;
                height: .8rem;
                padding: 0px 0.24rem !important;
                color: $font-component-light-color;
                border: .02rem solid $border-component-input-focus-color !important;
                padding-left: .28rem !important;

                &:focus {
                    background-color: transparent;
                    border-color: $font-component-hot-strong-color !important;
                }

                &::-webkit-input-placeholder {
                    /* WebKit browsers */
                    font-size: .22rem;
                    color: $font-component-muted-color;
                    opacity: .7;
                    font-weight: 100;
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    font-size: .22rem;
                    color: $font-component-muted-color;
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    font-size: .22rem;
                    color: $font-component-muted-color;
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    font-size: .22rem;
                    color: $font-component-muted-color;
                }
            }
        }
    }
    .btn_box{
        margin: .3rem .28rem;
    }
    .action_btn {
        // width: 96%;
        height: .7rem;
        border-radius: .15rem;
        // margin: .3rem auto;
        margin-top: .58rem;
        font-family: eryawenrunti;
        font-weight: 600;
        font-size: .28rem;
        color: $font-color;
        text-align: center;
        line-height: .7rem;
        cursor: pointer;
        background-color: $font-component-hot-strong-color;
        margin-bottom: 0;

        &.disabled {
            background: $bg-component-disabled-solid-color;
             color: var(--theme-soft-text);cursor: not-allowed;
            box-shadow: 0 .06rem 0 0 $shadow-component-base-color, 0 .02rem .03rem 0 $border-component-deep-color, 0 .02rem .03rem 0 $font-component-pale-color;
        }
    }

    .tips {
        color: #777;
        font-size: .22rem;
        text-align: left;
        padding-top: .04rem;
        font-weight: bold;
        // padding-left: .28rem;
    }
}
</style>
